import {PlayParticipantsConfig} from "./PlayParticipantsConfig";

export class PlayParticipantsProvider {

    public config: PlayParticipantsConfig = {
        permalinksEnabled: true,
        participantCount: 50,
        requestSize: 50,
    };

    public $get(): PlayParticipantsConfig {
        return this.config;
    }

    public static instance() {
        return new PlayParticipantsProvider;
    }
}